import React from 'react';

const OnSubmitModal = ({ show, success, message, onClose }) => {
  return (
    <div
      className={`modal fade ${show ? 'show' : ''}`}
      id="al-success-alert"
      tabIndex="-1"
      style={{ display: show ? 'block' : 'none' }}
       aria-labelledby="vertical-center-modal"
      aria-hidden={!show}
    >
      <div className="modal-dialog modal-sm">
        <div className={`modal-content modal-filled ${success ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>
          <div className="modal-body p-4">
            <div className="text-center">
              <i className={`ti ti-${success ? 'circle-check' : 'alert-circle'} fs-12`}></i>
              <p className={`mt-3 ${success ? 'text-success-50' : 'text-danger-50'}`}>
                {message}
              </p>
              <button
                type="button"
                className={`btn mb-1 waves-effect waves-light btn-rounded btn-outline-${success ? 'success' : 'danger'} my-2`}
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      
    </div>

    
    
  );
};

export default OnSubmitModal;